// extracted by mini-css-extract-plugin
module.exports = {"root":"MonthRangeSwitch_root__zFV__","range":"MonthRangeSwitch_range__DiUst","disabled":"MonthRangeSwitch_disabled__3Ojnr"};